import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import OverviewBox from '../../../shared/components/OverviewBox';

const Overview = ({ data = [] }) =>
  data.map(({ headline = '', title = '', amount = 0, icon, className = 'light-blue' }) => (
    <Grid item xs={12} sm={6} key={headline}>
      <OverviewBox headline={headline} title={title} amount={amount} icon={icon} className={className} />
    </Grid>
  ));

Overview.propTypes = {
  data: PropTypes.array
};

export default Overview;
